/**
 * Redux-saga
 */
import { put, call, takeLatest } from 'redux-saga/effects';

/**
 * Statistics
 */
import { AxiosResponse } from 'axios';

/**
 * Redux
 */
import {
  requestStatisticsAssetSuccess,
  requestStatisticsAssetFailure,
  requestStatisticsPartialSuccess,
  requestStatisticsPartialFailure,
  requestStatisticsDownloadSuccess,
  requestStatisticsDownloadFailure,
  requestStatisticsStreamingSuccess,
  requestStatisticsStreamingFailure,
  requestStatisticsLoginSuccess,
  requestStatisticsLoginFailure,
  requestStatisticsStorageSuccess,
  requestStatisticsStorageFailure,
} from 'redux/actions/statistics/actions';
import { throwError } from 'redux/actions/actions';

/**
 * Frameworks
 */
import { getAPI } from 'commons/framework/KeyFlowAPIRequest';
import KeyFlowResponse from 'commons/framework/KeyFlowResponse';
import { API } from 'commons/constants/KeyFlowAPI';

/**
 * Model
 */
import {
  REQUEST_STATISTICS_ASSET,
  REQUEST_STATISTICS_PARTIAL,
  REQUEST_STATISTICS_DOWNLOAD,
  REQUEST_STATISTICS_STREAMING,
  REQUEST_STATISTICS_LOGIN,
  REQUEST_STATISTICS_STORAGE,
  REQUEST_STATISTICS_EXPORT,
} from 'redux/actions/statistics/types';
import {
  StatisticsAssetResult,
  StatisticsStorageState,
  StatisticsTypeState,
} from 'redux/reducers/type';

function* requestStatisticsAssetSaga(action: RequestStatisticsAssetAction) {
  const { param } = action.payload;

  try {
    const response: AxiosResponse = yield call(getAPI, API.STATISTICS_ASSET, param);
    const keyFlowResponse = new KeyFlowResponse(response.data);

    const resultStatisticsAsset: StatisticsAssetResult[] = keyFlowResponse.getResult();

    yield put(requestStatisticsAssetSuccess({ statisticsAsset: resultStatisticsAsset }));
  } catch (error: any | Error) {
    yield put(throwError({ error }));
    yield put(requestStatisticsAssetFailure());
  }
}

function* requestStatisticsPartialSaga(action: RequestStatisticsPartialAction) {
  const { param } = action.payload;

  try {
    const response: AxiosResponse = yield call(getAPI, API.STATISTICS, param);
    const keyFlowResponse = new KeyFlowResponse(response.data);

    const resultStatisticsPartial: StatisticsTypeState[] = keyFlowResponse.getResult();

    yield put(requestStatisticsPartialSuccess({ statisticsPartial: resultStatisticsPartial }));
  } catch (error: any | Error) {
    yield put(throwError({ error }));
    yield put(requestStatisticsPartialFailure());
  }
}

function* requestStatisticsDownloadSaga(action: RequestStatisticsDownloadAction) {
  const { param } = action.payload;

  try {
    const response: AxiosResponse = yield call(getAPI, API.STATISTICS, param);
    const keyFlowResponse = new KeyFlowResponse(response.data);

    const resultStatisticsDownload: StatisticsTypeState[] = keyFlowResponse.getResult();

    yield put(requestStatisticsDownloadSuccess({ statisticsDownload: resultStatisticsDownload }));
  } catch (error: any | Error) {
    yield put(throwError({ error }));
    yield put(requestStatisticsDownloadFailure());
  }
}

function* requestStatisticsStreamingSaga(action: RequestStatisticsStreamingAction) {
  const { param } = action.payload;

  try {
    const response: AxiosResponse = yield call(getAPI, API.STATISTICS, param);
    const keyFlowResponse = new KeyFlowResponse(response.data);

    const resultStatisticsStreaming: StatisticsTypeState[] = keyFlowResponse.getResult();

    yield put(
      requestStatisticsStreamingSuccess({ statisticsStreaming: resultStatisticsStreaming }),
    );
  } catch (error: any | Error) {
    yield put(throwError({ error }));
    yield put(requestStatisticsStreamingFailure());
  }
}

function* requestStatisticsLoginSaga(action: RequestStatisticsLoginAction) {
  const { param } = action.payload;

  try {
    const response: AxiosResponse = yield call(getAPI, API.STATISTICS, param);
    const keyFlowResponse = new KeyFlowResponse(response.data);

    const resultStatisticsLogin: StatisticsTypeState[] = keyFlowResponse.getResult();

    yield put(requestStatisticsLoginSuccess({ statisticsLogin: resultStatisticsLogin }));
  } catch (error: any | Error) {
    yield put(throwError({ error }));
    yield put(requestStatisticsLoginFailure());
  }
}

function* requestStatisticsStorageSaga(action: RequestStatisticsStorageAction) {
  try {
    const response: AxiosResponse = yield call(getAPI, API.STATISTICS_STORAGE);
    const keyFlowResponse = new KeyFlowResponse(response.data);

    const resultStatisticsStorage: StatisticsStorageState[] = keyFlowResponse.getResult();

    yield put(requestStatisticsStorageSuccess({ statisticsStorage: resultStatisticsStorage }));
  } catch (error: any | Error) {
    yield put(throwError({ error }));
    yield put(requestStatisticsStorageFailure());
  }
}

function* requestStatisticsExport(action: RequestStatisticsExportAction) {
  const { param } = action.payload;

  try {
    const response: AxiosResponse = yield call(getAPI, API.STATISTICS_EXPORT, param);
    const keyFlowResponse = new KeyFlowResponse(response.data);

    console.log(keyFlowResponse);
  } catch (error) {}
}

export function* watchStatisticsSaga() {
  yield takeLatest(REQUEST_STATISTICS_ASSET, requestStatisticsAssetSaga);

  yield takeLatest(REQUEST_STATISTICS_PARTIAL, requestStatisticsPartialSaga);
  yield takeLatest(REQUEST_STATISTICS_DOWNLOAD, requestStatisticsDownloadSaga);
  yield takeLatest(REQUEST_STATISTICS_STREAMING, requestStatisticsStreamingSaga);
  yield takeLatest(REQUEST_STATISTICS_LOGIN, requestStatisticsLoginSaga);

  yield takeLatest(REQUEST_STATISTICS_STORAGE, requestStatisticsStorageSaga);

  yield takeLatest(REQUEST_STATISTICS_EXPORT, requestStatisticsExport);
}
